import { Maybe, VeevaVaultDocument } from 'generated/maya.types';

const useApprovedDocumentIdOptions = (
  veevaVaultDocument: VeevaVaultDocument[],
  currentDocumentId: Maybe<string> | undefined,
  isLoadedDocuments: boolean,
  isCurrentExecutingTeam: boolean,
) => {
  const approvedDocumentIdOptions = veevaVaultDocument.map((element: VeevaVaultDocument) => {
    return {
      id: element.id.toString(),
      label: `[${element.documentNumber}] [${element.status}] ${element.name}` as string,
    };
  });

  if (currentDocumentId && isLoadedDocuments) {
    const currentDocumentOption = approvedDocumentIdOptions.find((option) => option.id === currentDocumentId);

    if (!currentDocumentOption && isCurrentExecutingTeam) {
      approvedDocumentIdOptions.push({
        id: currentDocumentId,
        label: currentDocumentId,
      });
    }
  }

  return approvedDocumentIdOptions;
};

export default useApprovedDocumentIdOptions;
